import _find from 'lodash/find';
import _flatten from 'lodash/flatten';
import _toInteger from 'lodash/toInteger';
import d3Legacy from 'd3-legacy';
import 'scss/cndc_gen_bar_yearly.scss';
import moment from 'moment';
import { getCurrentD3Locale } from 'js/helpers/dateTimeAndNumberFormatting';
var PLOT_HEIGHT = 400; // const RANGE_ROUND_BANDS_SIZE = 0.1;

var Y_AXIS_LABEL_X = 10;
var Y_AXIS_LABEL_Y = -10;
var TOOLTIP_X_MARGIN = 20;
var TOOLTIP_Y_MARGIN = 15;
var BAR_PADDING = 30;
var TOOLTIP_SIDE_PADDING = 9;
var TOOLTIP_TOP_BOTTOM_PADDING = 7;
var TOOLTIP_TOP_MARGIN = 20;
export function initializePlot(props, data, a) {
  var countryID = props.countryID,
      plotID = props.plotID;
  if (!document.getElementById("".concat(plotID, "_graph"))) return;
  if (!data) return;
  var fullDateExtent = data.values.map(function (x) {
    return x.x;
  });
  var fullValueExtent = [0, d3Legacy.max(data.values.map(function (y) {
    return y.y;
  }))];
  var range = fullDateExtent;
  props.actions.setTotalDateRange(countryID, plotID, [moment(range[0]), moment(range[range.length - 1])]);
  var svg = d3Legacy.select(a.refs.graphSvg);
  svg.selectAll('*').remove();
  var xScale = d3Legacy.scale.ordinal().domain(fullDateExtent).rangeRoundBands([15, 350], 0.1); // 0.1 debe ser dinamico

  xScale.domain(fullDateExtent).rangeRoundBands([0, svg.node().getBoundingClientRect().width], 0.1); // 0.1 debe ser dinamico

  var yScale = d3Legacy.scale.linear().domain(fullValueExtent).range([PLOT_HEIGHT, 15]);
  yScale.domain(fullValueExtent).range([PLOT_HEIGHT, 15]); // ------------------------------------------------------- Eje X

  var xAxis = d3Legacy.svg.axis().scale(xScale).tickFormat(function (b) {
    return getCurrentD3Locale().timeFormat('%Y')(new Date(b));
  }).orient('bottom');
  var xAxisElement = svg.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', "translate(0,".concat(PLOT_HEIGHT, ")")).call(xAxis);
  xAxis.scale(xScale);
  xAxisElement.call(xAxis); // ------------------------------------------------------- Eje Y

  var yAxis = d3Legacy.svg.axis().scale(yScale).orient('left');
  var yAxisElement = svg.append('g').attr('class', 'cosmos-axis cosmos-axis--y').attr('transform', "translate(15,0)").call(yAxis);
  var yAxisElementText = yAxisElement.append('text').attr('transform', 'rotate(-90)').attr('class', 'cosmos-axis__label').attr('x', Y_AXIS_LABEL_X).attr('y', Y_AXIS_LABEL_Y);
  yAxis.scale(yScale);
  yAxisElement.call(yAxis);
  yAxisElementText.text('MW');
  var details = {
    xScale: xScale,
    svg: svg,
    fullValueExtent: fullValueExtent,
    fullDateExtent: fullDateExtent,
    yScale: yScale,
    xAxis: xAxis,
    xAxisElement: xAxisElement,
    yAxis: yAxis,
    yAxisElement: yAxisElement,
    yAxisElementText: yAxisElementText
  };
  updateBars(details, props.plot, 'gdp_per_mwh', data);
  props.actions.addEntry(props.countryID, props.plotID, 'details', details);
}

function updateBars(details, plot, key, data) {
  var newDetails = details;
  var xScale = details.xScale,
      svg = details.svg,
      fullValueExtent = details.fullValueExtent,
      yScale = details.yScale;

  var barMetadata = _find(plot.controls.data_types, {
    id: key
  });

  if (!barMetadata) return null;
  var barWidth = xScale.rangeBand();
  var cosmosBackgroundBars = svg.selectAll(".cosmos-graph__bar-background").data(data.values);
  var cosmosBars = svg.selectAll(".cosmos-graph__bar").data(data.values);
  cosmosBackgroundBars.enter().append('rect').attr('class', "cosmos-graph__bar-background");
  cosmosBackgroundBars.exit().remove(); // ---------------------------------------- colored bars

  cosmosBars.enter().append('rect').attr('class', "cosmos-graph__bar");
  cosmosBars.style('pointer-events', 'none').attr('rx', 3).attr('ry', 3).attr('stroke', barMetadata.color).attr('fill', barMetadata.color).attr('fill-opacity', 0.5).attr('x', function (e) {
    return xScale(mapPlotDataPointToDateTime(e)) + BAR_PADDING / 2;
  }).attr('width', barWidth - BAR_PADDING).attr('y', function (e) {
    return yScale(e.y);
  }).attr('height', function (e) {
    return getGraphHeight() - yScale(e.y);
  });
  cosmosBars.enter().append('rect').attr('class', "cosmos-graph__bar"); // ---------------------------------------- tooltip

  var tooltipNode = svg.append('g').attr('class', 'cosmos-focus-node').attr('display', 'none');
  var tooltipNodeRect = tooltipNode.append('rect').attr('rx', '5px').attr('ry', '5px').attr('class', 'cosmos-focus-node__tooltip');
  var tooltipNodeText = tooltipNode.append('text').attr('class', 'cosmos-focus-node__tooltip-text');
  newDetails.tooltipNode = tooltipNode;
  newDetails.tooltipNodeRect = tooltipNodeRect;
  newDetails.tooltipNodeText = tooltipNodeText; // ---------------------------------------- highlight bars (hover over)

  cosmosBackgroundBars.attr('fill-opacity', 0).attr('x', function (d) {
    return xScale(mapPlotDataPointToDateTime(d));
  }).attr('width', barWidth).attr('y', yScale(fullValueExtent[1]) - 1).attr('height', getGraphHeight() + 1).on('mouseover', onBarMouseOverGenerator(barMetadata, barWidth, key, newDetails)).on('mouseout', onBarMouseOutGenerator(newDetails));
}

function onBarMouseOverGenerator(barMetadata, barWidth, key, details) {
  // hover over
  return function (d) {
    var xScale = details.xScale,
        svg = details.svg,
        fullValueExtent = details.fullValueExtent,
        yScale = details.yScale,
        tooltipNode = details.tooltipNode,
        tooltipNodeText = details.tooltipNodeText,
        tooltipNodeRect = details.tooltipNodeRect;
    var backgroundBar = d3Legacy.select(this);
    backgroundBar.attr('fill-opacity', 0.5);
    var nodePositionX = xScale(mapPlotDataPointToDateTime(d));
    var nodePositionY = yScale(fullValueExtent[1]) + TOOLTIP_TOP_MARGIN;
    tooltipNode.attr('display', null);
    tooltipNodeText.style('text-anchor', 'start').attr('x', TOOLTIP_X_MARGIN + barWidth).attr('y', TOOLTIP_Y_MARGIN).text(["".concat(barMetadata.name, ":"), _toInteger(d[key]), key].join(' '));
    var textBBox = tooltipNodeText[0][0].getBBox();

    if (nodePositionX >= getSvgWidth(svg) / 2) {
      tooltipNodeText.style('text-anchor', 'end').attr('x', -TOOLTIP_X_MARGIN);
      textBBox = tooltipNodeText[0][0].getBBox();
    }

    tooltipNodeRect.attr('stroke', barMetadata.color).attr('width', textBBox.width + TOOLTIP_SIDE_PADDING * 2).attr('height', textBBox.height + TOOLTIP_TOP_BOTTOM_PADDING * 2).attr('x', textBBox.x - TOOLTIP_SIDE_PADDING).attr('y', textBBox.y - TOOLTIP_TOP_BOTTOM_PADDING);
    tooltipNode.attr('transform', "translate(".concat(nodePositionX, ",").concat(nodePositionY, ")"));
  };
}

export function onBarMouseOutGenerator(details) {
  // clea hover over
  var tooltipNode = details.tooltipNode;
  return function () {
    var backgroundBar = d3Legacy.select(this);
    backgroundBar.attr('fill-opacity', 0);
    tooltipNode.attr('display', 'none');
  };
}
export function getSvgWidth(svg) {
  return svg.node().getBoundingClientRect().width;
}
export function getGraphHeight() {
  return PLOT_HEIGHT;
}
export function formatXAxisDate(d) {
  var date = new Date(d);
  return getCurrentD3Locale().timeFormat('%Y')(date);
}
export function mapPlotDataToAllValues(data, type) {
  return _flatten(data.map(mapPlotDataGroupToDataPoints)).map(function (dataPoint) {
    return dataPoint[type];
  });
}
export function mapPlotDataGroupToDataPoints(dataGroup) {
  return dataGroup.values;
}
export function mapPlotDataPointToDateTime(dataPoint) {
  return dataPoint.x;
}